@if (isLoading() || prompts().length) {
    <div class="section-ai-prompts" data-testid="agent-suggested-prompts">
        <div class="section-ai-prompts-title d-flex align-items-center">
            <span>Suggested prompts</span>
            <button type="button"
                    class="btn btn-xs btn-circle btn-transparent btn-lightgray ml-1"
                    title="Suggest new prompts"
                    aria-label="Suggest new prompts"
                    data-testid="agent-suggested-prompts-refresh"
                    [disabled]="isLoading()"
                    (click)="refresh()">
                <svg ycnIcon name="icon-reset" role="img"></svg>
            </button>
        </div>
        <div class="section-ai-prompts-list">
            @if (isLoading()) {
                @for (row of skeletonRows; track row) {
                    <div class="section-ai-prompts-item" aria-hidden="true">
                        <div class="skeleton skeleton-blue skeleton-rounded width-full"></div>
                    </div>
                }
            } @else {
                @for (prompt of prompts(); track prompt) {
                    <div class="section-ai-prompts-item"
                         role="button"
                         tabindex="0"
                         data-testid="agent-suggested-prompt"
                         (click)="selectPrompt(prompt)"
                         (keydown.enter)="selectPrompt(prompt)"
                         (keydown.space)="$event.preventDefault(); selectPrompt(prompt)"
                    >
                        <span>{{ prompt }}</span>
                    </div>
                }
            }
        </div>
    </div>
}
